import { ArrowRight } from "lucide-react";
import MANAGER_DASHBOARD_IMAGE from "../assets/dashboard.jpeg";
import "../style/OverlapSection.css";
import { motion } from "framer-motion";

const OverlapSection = () => {
  return (
    <section className="manager-dashboard-section">
      <div className="container">
        {/* Section Header */}
        <motion.div
          className="dashboard-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h3 className="dashboard-title">Meet Your Dashboard</h3>
          <p className="dashboard-description mt-3">
              A clear snapshot of sales, jobs, customers and payments to keep everything running smoothly.
          </p>
        </motion.div>

        {/* Overlapping Dashboard Image */}
        <motion.div
          className="manager-dashboard-wrapper"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <img
            src={MANAGER_DASHBOARD_IMAGE}
            alt="Team Manager Dashboard"
            className="manager-dashboard-image"
          />
        </motion.div>

        {/* Description after image */}
        <motion.div
          className="dashboard-description-wrapper"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <p className="dashboard-description mb-2">
            Your dashboard gives you a complete overview of your business — sales performance, upcoming jobs, customer activity, payment status, and much more.
            Stay organised, take action quickly, and keep your day running smoothly all from a single, simple interface.
          </p>
          <a href={"#features"} className="text-primary text-decoration-none">
           View Dashboard Features <ArrowRight className="w-4 h-4"/>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default OverlapSection;